// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1___b62a7440a8b6f41b26d","cls2":"UserTaggingPingBodyStyles-cls2__a04c96e49dc140acdf3f UserTaggingPingBodyStyles-cls1___b62a7440a8b6f41b26d"};